<template>
  <section class="page-wrapper fluid-container">
    <div class="calculateur-wrapper max-container">
      <h1 class="big-title">{{ $t('Obtenez un prix en quelques clics') }}</h1>

      <p class="notice">
        {{ $t('*Les prix sont sujet à changement sans préavis. ') }}
      </p>

      <article class="calc-product-sheet" v-if="selectedProduct && products">
        <img class="img-product" :src="'/img/tempos/' + products[0].WEB + '.jpg'" alt="Tempo - Produit">
        <div class="sheet-content">
          <h2 class="medium-title" >
            {{ selectedProduct.replaceAll('-', ' ').toUpperCase() }}
            <span v-if="switch7">(7' & 7'10)</span>
          </h2>
          <a class="sheet-link" v-if="currentLang === 'fr'" href="https://abristempo.com/categorie-produit/residentiel/">{{ $t('Sélectionner un autre produit') }}</a>
          <a class="sheet-link" v-else href="https://abristempo.com/en/product-category/residential/">{{ $t('Sélectionner un autre produit') }}</a>
        </div>
      </article>

      <div class="form">
        <form v-if="aggregateLargeurs && aggregateLargeurs.length" action="" @submit="calcPrice">
          <div class="row">
            <label class="input" for="Largeur">
              <span class="small-title">{{ $t('Largeur') }}</span>
              <select id="Largeur" required v-model="selectedLargeur" @change="resetPrice()">
                <option value="" disabled selected>---</option>
                <option :value="i" v-for="i in aggregateLargeurs" :key="i">
                  {{ i }}
                </option>
              </select>
            </label>

            <label class="input" for="Longueur">
              <span class="small-title">{{ $t('Longueur') }}</span>
              <select id="Longueur" required v-model="selectedLongueur" :disabled="!aggregateLongueurs.length" @change="resetPrice()">
                <option value="" disabled selected>---</option>
                <option :value="i" v-for="i in aggregateLongueurs" :key="i">
                  {{ i }}
                </option>
              </select>
            </label>

            <label class="input" for="Hauteur">
              <span class="small-title">{{ $t('Hauteur') }}</span>
              <select id="Hauteur" required v-model="selectedHauteur" :disabled="!aggregateHauteurs.length" @change="resetPrice()">
                <option value="" disabled selected>---</option>
                <option :value="i" v-for="i in aggregateHauteurs" :key="i">
                  {{ i }}
                </option>
              </select>
            </label>
          </div>

          <div class="results" v-if="price">
            <strong class="price">
              {{ price }}$
              <span class="code">{{ code }}</span>
            </strong>

            <strong class="price cover-price" v-if="matchingCover">
              <span class="suptitle">({{ $t('Toile seulement') }})</span>
              {{ matchingCover.PRIX2022 }}$
              <span class="code">{{ matchingCover.Code }}</span>
            </strong>
          </div>

          <div class="results" v-else>
            <button class="site-btn icon-right" type="submit">
              <span>{{ $t('Calculer') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-calculator" width="22" viewBox="0 0 24 24" stroke-width="1" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <rect x="4" y="3" width="16" height="18" rx="2" />
                <rect x="8" y="7" width="8" height="3" rx="1" />
                <line x1="8" y1="14" x2="8" y2="14.01" />
                <line x1="12" y1="14" x2="12" y2="14.01" />
                <line x1="16" y1="14" x2="16" y2="14.01" />
                <line x1="8" y1="17" x2="8" y2="17.01" />
                <line x1="12" y1="17" x2="12" y2="17.01" />
                <line x1="16" y1="17" x2="16" y2="17.01" />
              </svg>
            </button>
          </div>
        </form>

        <div v-else class="loader-wrapper">
          <svg class="loader" width="38" height="38" xmlns="http://www.w3.org/2000/svg" stroke="#596778">
            <g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd">
              <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
              <path d="M36 18c0-9.94-8.06-18-18-18">
                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
              </path>
            </g>
          </svg>
        </div>

        <div class="results results-cta" :class="{ 'is-active': price }">
          <article class="calc-product-sheet sheet-result">
            <div class="img-product-wrap">
              <img class="img-product" src="@/assets/img/video-cover.png" alt="Tempo - Produit">
              <a href="https://www.youtube.com/watch?v=v8i7hbinWBI" class="glightbox video">
                <img class="play-btn" src="@/assets/img/play.svg" alt="Play">
              </a>
            </div>
            <div class="sheet-content">
              <h2 class="medium-title" >
                {{ $t('La différence TEMPO') }}
              </h2>
              <p class="regular-text">
                {{ $t("Abris Tempo est le pionnier dans la conception et la fabrication d'abris d'auto au Québec.") }}
              </p>
              <a
                href="https://www.youtube.com/watch?v=v8i7hbinWBI"
                class="sheet-link glightbox video"
              >
                {{ $t('Voir la vidéo') }}
              </a>
              <a
                :href="currentLang === 'fr' ? 'https://abristempo.com/points-de-vente/' : 'https://abristempo.com/en/sales-points/'"
                target="_blank"
                rel="noopener noreferrer"
                class="site-btn  icon-right is-black margin"
                type="submit"
              >
                <span>{{ $t('Points de vente') }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="icon-tabler-map-2" width="22" viewBox="0 0 24 24" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <line x1="18" y1="6" x2="18" y2="6.01" />
                  <path d="M18 13l-3.5 -5a4 4 0 1 1 7 0l-3.5 5" />
                  <polyline points="10.5 4.75 9 4 3 7 3 20 9 17 15 20 21 17 21 15" />
                  <line x1="9" y1="4" x2="9" y2="17" />
                  <line x1="15" y1="15" x2="15" y2="20" />
                </svg>
              </a>
              <a
                :href="currentLang === 'fr' ? 'https://abristempo.com/nous-joindre/?code=' + code + '' : 'https://abristempo.com/en/contact-us/?code=' + code + ''"
                target="_blank"
                rel="noopener noreferer"
                class="site-btn icon-right"
                type="submit"
              >
                <span>{{ $t('Nous joindre') }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-phone-call" width="22" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
                  <path d="M15 7a2 2 0 0 1 2 2" />
                  <path d="M15 3a6 6 0 0 1 6 6" />
                </svg>
              </a>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { isNil } from 'lodash'
import { mapState } from 'vuex'
import GLightbox from 'glightbox'
import ProductsDB from '@/firebase/products-db'
import CoversDB from '@/firebase/covers-db'

export default {
  data() {
    return {
      selectedProduct: '',
      selectedLargeur: '',
      selectedLongueur: '',
      selectedHauteur: '',
      products: null,
      covers: null,
      price: null,
      code: null,
      matchingCover: null,
      lightboxElement: null,
      switch7: false
    }
  },
  head() {
    return {
      title: {
        inner: 'Obtenez un prix en quelques clics'
      },
      meta: [
        {
          name: 'description',
          content: `Avec le calculateur Tempo, obtenez un prix en quelques clics.`,
          id: 'desc'
        }
      ]
    }
  },
  watch: {
    $route: {
      async handler($route) {
        if (!isNil($route)) {
          if ($route.query.product) {
            this.selectedProduct = $route.query.product

            if (this.selectedProduct === 'abri-double-rond-7') {
              this.selectedProduct = 'abri-double-rond'
              this.switch7 = true
            }

            if (this.selectedProduct === 'domed-double-car-shelter-7') {
              this.selectedProduct = 'domed-double-car-shelter'
              this.switch7 = true
            }

            if (this.selectedProduct === 'abri-double-rond' || this.selectedProduct === 'domed-double-car-shelter') {
              this.switch7 = true
            }

            // Query FireStore for proper products
            const prodcutsDb = new ProductsDB()
            const coversDb = new CoversDB()
            const locale = this.$route.meta.lang === 'fr' ? '' : ' EN'

            this.products = await prodcutsDb.readAll([[`WEB${locale}`, '==', this.selectedProduct]])
            this.covers = await coversDb.readAll([[`WEB${locale}`, '==', this.selectedProduct]])

            // this.products = productsList.filter(i => i[`WEB${locale}`] === this.selectedProduct)
            // this.covers = coversList.filter(i => i[`WEB${locale}`] === this.selectedProduct)

            // Activate Video Lightbox
            this.lightboxElement = GLightbox()
          }
        }
      },
      immediate: true
    }
  },

  computed: {
    currentLang() {
      return this.$i18n.locale
    },
    aggregateLargeurs() {
      if (!this.products || !this.products.length) {
        return []
      }

      const largeurs = []
      this.products.forEach(item => {
        largeurs.push(item.LARGEUR)
      })

      return [...new Set(largeurs)]
    },
    aggregateLongueurs() {
      if (!this.products || !this.products.length || !this.selectedLargeur) {
        return []
      }

      const longueurs = []
      this.products.forEach(item => {
        if (item.LARGEUR === this.selectedLargeur) {
          longueurs.push(item.LONGUEUR)
        }
      })

      return [...new Set(longueurs)]
    },
    aggregateHauteurs() {
      if (!this.products || !this.products.length || !this.selectedLongueur || !this.selectedLargeur) {
        return []
      }

      const hauteurs = []
      this.products.forEach(item => {
        if (item.LONGUEUR === this.selectedLongueur && item.LARGEUR === this.selectedLargeur) {
          hauteurs.push(item.HAUTEUR)
        }
      })

      return [...new Set(hauteurs)]
    },
    ...mapState('app', ['appTitle'])
  },
  methods: {
    resetPrice() {
      this.price = null
      this.code = null
    },
    calcPrice(e) {
      e.preventDefault()

      if (!this.selectedLargeur || !this.selectedLongueur || !this.selectedHauteur) {
        return null
      }

      const locale = this.$route.meta.lang === 'fr' ? '' : ' EN'
      const productsList = this.products.filter(i => i[`WEB${locale}`] === this.selectedProduct)
      let productRow = []

      console.log(123)

      // console.log({ productsList })
      if (productsList.length) {
        productRow = productsList.filter(r => {
          return r.LARGEUR === this.selectedLargeur && r.LONGUEUR === this.selectedLongueur && r.HAUTEUR === this.selectedHauteur
        })
      }
      console.log(productRow)
      console.log(this.price)
      if (productRow.length) {
        this.price = productRow[0].PRIX2022
        this.code = productRow[0]['NOUVEAU CODE']

        if (this.covers && this.covers.length) {
          const productCode = this.code
          const productCodeNormalized = productCode.replace( /[^0-9]/g, '' )

          // const coverCode = productCode.replace('A', 'T')

          this.matchingCover = this.covers.find(c => {
            return c.Code.includes(productCodeNormalized)
          })
        }

        this.lightboxElement.reload()
      } else {
        this.price = 'Not Found'
        this.code = null
      }
      return true
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.page-wrapper {
  padding-bottom: 5vw;
}

.calculateur-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;

  .calc-product-sheet {
    display: flex;
    align-items: stretch;
    justify-content: space-between;

    width: 80%;
    margin: 10px 0;
    background: #fff;
    border-radius: $radius;

    @media (max-width: 767px) {
      width: 80%;
      margin: 0;
      flex-direction: column;
    }

    .img-product {
      max-width: 200px;
      background: $light;

      @media (max-width: 767px) {
        max-width: 100%;
        border-top-right-radius: $radius;
      }
    }

    .sheet-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      width: 100%;
      padding: 25px;
    }

    .medium-title {
      margin-bottom: 15px;
    }

    .regular-text {
      text-align: left;
      padding-bottom: 15px;
      line-height: 1.35;
      color: rgba(0, 0, 0, 0.65);
    }

    .sheet-link {
      color: $colorAccent1;

      &:hover {
        color: $dark;
        transition: color $t2 $bounce 0s;
      }
    }
  }

  .sheet-result {
    width: 100%;
    margin-bottom: 45px;

    .img-product-wrap {
      position: relative;

      .play-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;

        width: 55px;
        padding: 10px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.12);
      }
    }

    .img-product {
      width: 200px;
      height: 100%;
      object-fit: cover;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;

      @media (max-width: 767px) {
        width: 100%;
        height: 275px;
        object-position: center top;
        border-bottom-left-radius: 0;
      }
    }

    .site-btn {
      width: 100%;
    }
  }
}

.form {
  width: 80%;

  @media (max-width: 767px) {
    width: 100%;
  }

  .row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    width: 100%;
    padding: 25px 0;
  }

  .input {
    display: block;
    width: calc(92% / 3);

    .small-title {
      margin-bottom: 10px;

      @media (max-width: 767px) {
        margin-bottom: 5px;
      }
    }

    input,
    select {
      width: 100%;
      border-radius: $radius;
      font-size: 14px;
      color: $dark;
      font-family: $font;
      border: none;
      padding: 14px 10px;
      color: #535353;

      -webkit-appearance: none;
      background: url('../assets/img/down.svg');
      background-color: #fff;
      background-repeat: no-repeat;
      background-position: center right 15px;
      background-size: 22px;
      cursor: pointer;

      &:disabled {
        opacity: 0.35;
      }
    }

    span {
      display: block;
    }
  }
}

.results {
  text-align: center;

  .price {
    display: block;
    padding: 20px 0;
    padding-bottom: 40px;
    font-size: 56px;
    font-weight: normal;

    .code {
      display: block;
      padding: 8px 0;
      font-size: 16px;
      color: rgba($dark, 0.55);
    }

    @media (max-width: 767px) {
      font-size: 45px;
      padding: 10px 0;
      padding-bottom: 20px;
    }
  }

  .site-btn {
    margin-top: 25px;
  }
}

.loader-wrapper {
  display: block;
  text-align: center;
  padding: 25px;
}

.results-cta {
  height: 0;
  overflow: hidden;

  &.is-active {
    height: auto;
  }
}

.cover-price {
  display: block;
  position: relative;
  transform: scale(0.755) translate(0, -75px);
  opacity: 0.757;
  margin-bottom: -80px;

  @media (max-width: 767px) {
    transform: scale(0.755) translate(0, -35px);
    margin-bottom: -40px;
  }
}

.suptitle {
  font-size: 30%;
  display: block;
  margin-bottom: 5px;
  color: $colorAccent1;
}

.notice {
  position: absolute;
  left: 20px;
  bottom: 20px;

  font-size: 12px;
  color: rgba(#000, 0.475);

  @media (max-width: 767px) {
    position: relative;
    width: 100%;
    left: 0;
    bottom: 0;
    text-align: center;
    padding-bottom: 20px;
  }
}
</style>
